import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-[color:var(--azsam-stone)] bg-[color:var(--azsam-cream)]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2 max-w-md">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-[color:var(--azsam-clay)] text-white flex items-center justify-center font-heading text-lg font-semibold">
              A
            </div>
            <div className="font-heading text-2xl">AzSAM</div>
          </div>
          <p className="mt-5 text-sm text-[color:var(--azsam-ink-soft)] leading-relaxed">
            The Arizona Society of Addiction Medicine is a community of addiction specialists advancing
            evidence-based, compassionate treatment for substance use disorders across the
            Sonoran Desert and beyond.
          </p>
        </div>

        <div>
          <div className="overline mb-4">Explore</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/about" className="hover:text-[color:var(--azsam-clay)]">About &amp; Board</Link></li>
            <li><Link to="/events" className="hover:text-[color:var(--azsam-clay)]">Events &amp; CME</Link></li>
            <li><Link to="/resources" className="hover:text-[color:var(--azsam-clay)]">Clinical Resources</Link></li>
            <li><Link to="/news" className="hover:text-[color:var(--azsam-clay)]">AzSAM Initiatives</Link></li>
            <li><Link to="/committees" className="hover:text-[color:var(--azsam-clay)]">Committees</Link></li>
            <li><Link to="/solicit-support" className="hover:text-[color:var(--azsam-clay)]">How Can We Help You?</Link></li>
            <li><Link to="/contact" className="hover:text-[color:var(--azsam-clay)]">Contact us</Link></li>
          </ul>
        </div>

        <div>
          <div className="overline mb-4">Reach us</div>
          <ul className="space-y-3 text-sm text-[color:var(--azsam-ink-soft)]">
            <li className="flex items-start gap-2"><MapPin size={16} className="mt-0.5" /> Phoenix, Arizona</li>
            <li className="flex items-start gap-2"><Mail size={16} className="mt-0.5" /> Leadership@AZ-SAM.org</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[color:var(--azsam-stone)]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between text-xs text-[color:var(--azsam-ink-soft)]">
          <div>© {new Date().getFullYear()} Arizona Society of Addiction Medicine. All rights reserved.</div>
          <div>Chapter affiliate of the American Society of Addiction Medicine.</div>
        </div>
      </div>
    </footer>
  );
}
